import i18n from 'helpers/i18n';
import messages from './messages';
import { useState } from 'react';
import { RejectVideoButton } from './RejectVideoButton';
import { claimVideo } from 'actions/video-obs/double-coders';
import { Button, Checkbox, Text } from '@teachstonellc/component-library';

interface ReviewInputProps {
  /** The ID of the video upload, used for claiming or rejecting the video. */
  videoUploadId: number;

  /** Callback function invoked when the video is successfully claimed. */
  onVideoClaimed: () => void;

  /** Callback function invoked when the video is rejected. */
  onVideoRejected: () => void;
}

export function ReviewInput({
  videoUploadId,
  onVideoClaimed,
  onVideoRejected
}: ReviewInputProps) {
  const [educatorCheckbox, setEducatorCheckbox] = useState(false);
  const [centerCheckbox, setCenterCheckbox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function handleClaimVideo() {
    setIsLoading(true);
    await claimVideo(videoUploadId);
    setIsLoading(false);
    onVideoClaimed();
  }

  return (
    <div>
      <div className="p-6 bg-ds-white rounded-xl">
        <Text variant="h4" as="div">
          {i18n.ft(messages.review.sidebarTitle)}
        </Text>

        <div className="mt-3 space-y-2">
          <Checkbox
            alignInput="center"
            label={i18n.ft(messages.review.sidebarItem1)}
            checked={educatorCheckbox}
            onChange={() => setEducatorCheckbox(!educatorCheckbox)}
          />
          <Checkbox
            alignInput="center"
            label={i18n.ft(messages.review.sidebarItem2)}
            checked={centerCheckbox}
            onChange={() => setCenterCheckbox(!centerCheckbox)}
          />
        </div>
      </div>

      <div className="mt-6 space-y-4">
        <Button
          fullWidth
          variant="primary"
          size="large"
          onClick={handleClaimVideo}
          loading={isLoading}
          disabled={!(educatorCheckbox && centerCheckbox) || isLoading}
        >
          {i18n.ft(messages.review.claimButton)}
        </Button>

        <RejectVideoButton
          variant="secondary"
          videoUploadId={videoUploadId}
          onVideoRejected={onVideoRejected}
        >
          {i18n.ft(messages.review.nextButton)}
        </RejectVideoButton>
      </div>
    </div>
  );
}
